import type { SVGProps } from 'react';
const SvgPhotoCameraBack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#photo_camera_back_svg__a)">
      <path
        fill="currentColor"
        d="M20 5c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h3.17L9 3h6l1.83 2H20Zm0 14V7H4v12h16Zm-6-7-3 3.72L9 13l-3 4h12l-4-5Z"
      />
    </g>
    <defs>
      <clipPath id="photo_camera_back_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPhotoCameraBack;
